import Backbone from 'backbone'
import _ from 'underscore'
import PromoCodeButtonViewTemplate from '../templates/promo-code-button.tpl'
import user from '../user'

const PromoCodeButtonView = Backbone.View.extend({
    events: {
        'click': 'promoCode',
    },
    initialize() {
        this.template = _.template(PromoCodeButtonViewTemplate)

        // listen to the purchased
        this.listenTo(user.get('purchased'), 'add', this.render)

        // and listen to the user for the logout
        this.listenTo(user, 'change', this.render)
    },
    render() {
        const purchased = user.get('purchased').purchased()

        if (purchased === false) {
            this.$el.html(this.template())
        }

        return this
    },
    promoCode() {
        if (user.get('uid') === null) {
            Backbone.history.navigate('free-book', {trigger: true})
        } else {
            Backbone.history.navigate('promo-code', {trigger: true})
        }
    }
})

export default PromoCodeButtonView